import IntegrationService from 'services/integration';
import IntegrationActionCreator from 'action_creators/integration';

// We're only executing when inside an iframe.
if (window.self !== window.top) {
  // Start listening for `message` events
  IntegrationService.attachListener();

  // Initial parent query.. aight?
  IntegrationActionCreator.queryParentViewport();

  document.body.style.overflow = 'hidden';
  document.getElementsByTagName('html')[0].style.overflow = 'hidden';
}
